import FormControl from "@mui/material/FormControl"
import { Checkbox, FormControlLabel } from "@mui/material"
import { Controller, FieldValues, Control, Path } from "react-hook-form"

interface ControlledCheckBoxProps<T extends FieldValues> {
  label: string
  name: Path<T>
  control: Control<T>
}

const ControlledCheckBox = <T extends FieldValues>({
  label,
  control,
  name,
}: ControlledCheckBoxProps<T>) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value } }) => (
        <FormControl fullWidth>
          <FormControlLabel
            control={
              <Checkbox checked={value} onChange={() => onChange(!value)} />
            }
            label={label}
          />
        </FormControl>
      )}
    />
  )
}

export default ControlledCheckBox
